document.addEventListener('DOMContentLoaded', () => {
    let popup = document.querySelector('.popup');
    if (popup)
    {
        let cookie = document.cookie.indexOf('hb_popup') > -1;
        if (!cookie)
        {
            popup.classList.add('visible');
        }
    }
});

document.addEventListener('click', e => {
    if (!e.target.closest)
    {
        return;
    }

    if (e.target.closest('.popup-close') || e.target.closest('.popup-content a'))
    {
        // Set a cookie for 1 week hb_popup=1
        document.cookie = "hb_popup=1; path=/; max-age=" + 7 * 24 * 60 * 60 + ";";

        e.target.closest('.popup').classList.remove('visible');
    }
});
